module.exports = __webpack_public_path__ + "img/sound-on-icon.9e6bf42f.svg";